<template>
    <scroll-wrap>
        <div class="main-box">
            <div class="content-wrap">
                <div class="country">
                    <img :src="require(`./../../assets/image/${$store.state.record.country}.png`)" alt="">
                </div>
                <div class="main-area">
                    <div class="main-area-box">
                        <div class="store-item" @click="storeIn($store.state.record.store['A仓'],'AIn')">
                            <div class="wrap center">
                                A仓
                            </div>
                            <div class="wrap">
                                <div class="tit">
                                    <span class="zh">
                                        外箱条码
                                    </span>
                                    <span class="en">
                                        OUTER BOX BARCODE
                                    </span>
                                </div>
                                <div class="cont">
                                    <div class="code-top">
                                        {{$store.state.record.store['A仓'].barcode}}
                                    </div>
                                    <img src="./../../assets/image/sweep/code.png" alt="">
                                    <div class="code-top">
                                        {{$store.state.record.store['A仓'].barcode}}
                                    </div>
                                </div>
                            </div>
                            <div class="wrap">
                                <div class="tit">
                                <span class="zh">
                                    单品条码
                                </span>
                                    <span class="en">
                                    SINGLE PRODUCT BARCODE
                                </span>
                                </div>
                                <div class="cont">
                                    <div class="code-top">
                                        {{$store.state.record.store['A仓'].product.barcode}}
                                    </div>
                                    <img src="./../../assets/image/sweep/code.png" alt="">
                                    <div class="code-top">
                                        {{$store.state.record.store['A仓'].product.barcode}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="store-item" @click="storeIn($store.state.record.store['B仓'],'BIn')">
                            <div class="wrap center">
                                B仓
                            </div>
                            <div class="wrap">
                                <div class="tit">
                                <span class="zh">
                                    外箱条码
                                </span>
                                    <span class="en">
                                    OUTER BOX BARCODE
                                </span>
                                </div>
                                <div class="cont">
                                    <div class="code-top">
                                        {{$store.state.record.store['B仓'].barcode}}
                                    </div>
                                    <img src="./../../assets/image/sweep/code.png" alt="">
                                    <div class="code-top">
                                        {{$store.state.record.store['B仓'].barcode}}
                                    </div>
                                </div>
                            </div>
                            <div class="wrap">
                                <div class="tit">
                                <span class="zh">
                                    单品条码
                                </span>
                                    <span class="en">
                                    SINGLE PRODUCT BARCODE
                                </span>
                                </div>
                                <div class="cont">
                                    <div class="code-top">
                                        {{$store.state.record.store['B仓'].product.barcode}}
                                    </div>
                                    <img src="./../../assets/image/sweep/code.png" alt="">
                                    <div class="code-top">
                                        {{$store.state.record.store['B仓'].product.barcode}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="foot">
                <span class="btn" @click="$router.push('/overseas-warehouses/simulationCase')" v-if="BIn && AIn">
                    下一步
                </span>
            </div>
            <dialogue v-if="dialogueShow" :talk-list-init="talkList" @close="dialogueShow=false"></dialogue>
        </div>
    </scroll-wrap>
</template>

<script>
    import dialogue from '../../components/dialogue'
    export default {
        name: "investigate",
        data() {
            return {
                AIn:false,
                BIn:false,
                dialogueShow:true
            }
        },
        components: {
            dialogue
        },
        created() {

        },
        computed:{
            talkList(){
                return [
                    {
                        txt: `多选题：货品入仓前，在海外仓信息系统中对货品的定义必须包含哪些？`,
                        type: 'teacher',
                        options: ["A、物品名称","B、SKU","C、重量","D、生产商"],
                        rightAnswers: '正确答案: ABC',
                        answer: [],
                        value: ["A、物品名称","B、SKU","C、重量"],
                        questionType:'multiple',
                        questionIndex:8,
                        score:8,
                    },
                    {
                        txt: `排序题：按照操作顺序，海外仓入库流程依次为`,
                        type: 'teacher',
                        options: ["A、仓库收货","B、上架存储","C、货品检验","D、库存"],
                        rightAnswers: '正确答案: ACBD',
                        answer: [],
                        value: ["A、仓库收货","C、货品检验","B、上架存储","D、库存"],
                        questionType:'ranking',
                        questionIndex:9,
                        score:8,
                        placeholder:'请点击上方选项进行排序'
                    },
                    {
                        txt: `判断题：海外仓的入库清单包括三方面：采购预约入库、退件预约入库、调拨预约入库。是否正确。`,
                        type: 'teacher',
                        options: ["正确","错误"],
                        rightAnswers: '正确答案: 正确',
                        answer: '',
                        value: "正确",
                        questionType:'choice',
                        questionIndex:10,
                        score:8,
                    },
                    {
                        txt: `判断题：海外仓可以作为海外中转仓库，特别是旺季时候有些卖家出现亚马逊平台断货，如果海外仓有货，可以直接从海外仓调拨到FBA仓，节省从国内发货的时间，及时补足库存。是否正确？`,
                        type: 'teacher',
                        options: ["正确","错误"],
                        rightAnswers: '正确答案: 正确',
                        answer: '',
                        value: "正确",
                        questionType:'choice',
                        questionIndex:11,
                        score:8,
                    },
                    {
                        txt: `排序题：按照操作顺序，海外仓出库流程依次为订单配（补）货、（ ）、（ ）、（ ）、（ ）、称重出库、派送/签收。`,
                        type: 'teacher',
                        options: ["A、订单复核","B、建立批次","C、拣货","D、包装"],
                        rightAnswers: '正确答案: BCAD',
                        answer: [],
                        value: ["B、建立批次","C、拣货","A、订单复核","D、包装"],
                        questionType:'ranking',
                        questionIndex:12,
                        score:8,
                        placeholder:'请点击上方选项进行排序'
                    },
                    {
                        txt: `多选题：海外仓的费用除了头程费用，还包括哪些？`,
                        type: 'teacher',
                        options: ["A、国际海运运费","B、订单操作费","C、仓租费","D、海外本地派送费"],
                        rightAnswers: '正确答案: BCD',
                        answer: [],
                        value: ["B、订单操作费","C、仓租费","D、海外本地派送费"],
                        questionType:'multiple',
                        questionIndex:13,
                        score:8,
                    },
                ]
            }
        },
        methods:{
            storeIn(store,status){
                this.axios.post('/student/store/exp/in/sure',{
                    storeExp:{id:store.storeExp.id},
                    experiment:{id:this.$store.state.record.experiment.id},
                    barcode:store.barcode
                }).then(res=>{
                    if(res.succeed){
                        this.$swal({
                            text:`${store.storeExp.store.name}扫码成功`,
                            icon:'success',
                        })
                        this[status] = true
                    }else {
                        this.$swal({
                            text:res.message,
                            icon:'warning',
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .main-box {
        height: 100%;

        .content-wrap {
            display: flex;
            position: relative;
            min-height: calc(100% - 88px);
            justify-content: flex-start;
            flex-grow: 1;

            .country {
                position: relative;
                width: 364px;min-width:364px;

                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .main-area {
                flex-grow: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 20px;

                h6 {
                    width: 100%;
                    text-align: left;
                    padding-left: 60px;
                    line-height: 60px;
                    font-size: 16px;

                    i {
                        color: red;
                        margin-right: 3px;
                    }

                    e {
                        color: #004BFF;
                    }
                }

                .main-area-box {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;

                    .store-item {
                        display: flex;
                        margin-bottom: 6px;
                        background-color: #FFFFFF;
                        border: 1px solid #adadad;
                        &:hover {
                            cursor: url("../../assets/image/sweep/laba.png"),auto;
                            box-shadow: 0 0 10px #adadad;
                            transition: box-shadow 0.3s ease-in-out;
                        }
                        .wrap {
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                            padding: 10px 20px;

                            &.center {
                                justify-content: center;
                                font-size: 20px;
                                font-weight: bolder;
                                color: #FFFFFF;
                                background: #5180fc;
                            }

                            div.tit {
                                margin-bottom: 10px;
                                display: flex;
                                flex-direction: column;
                                align-items: flex-start;

                                span.zh {
                                    font-size: 22px;
                                    font-weight: bolder;
                                }

                                span.en {
                                    font-size: 12px;
                                }
                            }

                            div.cont {
                                position: relative;
                                &:hover {

                                }
                                .code-top {
                                    font-size: 22px;
                                    font-weight: bolder;
                                }
                                img {
                                    margin: 20px 0 6px 0;
                                }

                            }
                        }
                    }


                }
            }
        }

        > .foot {
            background: #EEEFEF;
            display: flex;
            align-items: center;
            justify-content: center;border-radius:0 0 10px 10px;
            height: 88px;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;

            span.btn {
                cursor: pointer;
                padding: 10px 38px;
                background: #004BFF;
                color: #FFFFFF;
                border-radius: 100px;
                margin-right: 40px;

                &:hover {
                    opacity: 0.8;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>
